jQuery(function () {
    const checkoutModules = window.TlpCheckoutModules || {};

    ['ajax', 'coupon', 'steps'].forEach((moduleName) => {
        const moduleInstance = checkoutModules[moduleName];

        if (moduleInstance && typeof moduleInstance.init === 'function') {
            moduleInstance.init();
        }
    });
});